// Inline nanoid implementation (no CDN dependency)
function nanoid(size = 21) {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
  const bytes = crypto.getRandomValues(new Uint8Array(size));
  let id = '';
  for (let i = 0; i < size; i++) {
    id += alphabet[bytes[i] & 63];
  }
  return id;
}

document.addEventListener('DOMContentLoaded', function() {
  const currentProductQuantity = document.querySelector('.ProductForm [name="quantity"]');
  const widget = document.querySelector('.recharge-subscription-widget');
  if (!widget) return;

  // Get all elements
  const subscriptionOptionsSubscribe = widget.querySelector('#subscription-options-subscribe');
  const subscriptionOptionsOnetime = widget.querySelector('#subscription-options-onetime');
  const subscribeOption = widget.querySelector('[data-option="subscribe"]');
  const onetimeOption = widget.querySelector('[data-option="onetime"]') || widget.querySelector('.onetime-option');
  const subscribeRadio = widget.querySelector('#subscribe-option');
  const onetimeRadio = widget.querySelector('#onetime-option');
  const sellingPlanInput = widget.querySelector('.selling-plan-input');
  const discountInput = widget.querySelector('.discount-input');
  let rcBundleInput = widget.querySelector('.rc-bundle-input');
  const rcBundleParentInput = widget.querySelector('.rc-bundle-parent-input');
  const rcBundleVariantInput = widget.querySelector('.rc-bundle-variant-input');
  const rcBundleCollectionIdInput = widget.querySelector('.rc-bundle-collection-id-input');


  let currentOption = 'subscribe';
  let basePrice = parseFloat(widget.dataset.basePrice) || 0;
  let price = basePrice;
  let productBundleId = widget.dataset.productBundleId;
  let parentBundle = widget.dataset.parentBundle;
  let variantBundleId = widget.dataset.variantBundleId;
  let collectionBundleId = widget.dataset.collectionBundleId;

  // Tier plan IDs
  let sellingPlanId = widget.dataset.sellingPlan || '';

  // Configurable discount tiers from theme settings
  let tier1Discount = parseInt(widget.dataset.tier1Discount) || 15;
  let tier2Discount = parseInt(widget.dataset.tier2Discount) || 17;
  let tier3Discount = parseInt(widget.dataset.tier3Discount) || 20;

  /* ── Variant change support ───────────────────────────────────────────────
     The variant selector is Preact-rendered (snippets/product-options.liquid)
     and only writes the chosen id into the hidden input[name="id"]. That is a
     DOM *property* assignment: it fires no change event and leaves no mutation
     record, so nothing downstream ever learns the variant changed. Meanwhile
     every price in this widget is rendered server-side from
     selected_or_first_available_variant, and basePrice above is read once at
     DOMContentLoaded and cached in this closure.

     Net effect before this block: picking a different variant left the widget
     showing the FIRST variant's price forever — e.g. Calm (Beauty) still
     quoted the $84.00 24-Day Supply after the $14.00 3-Day Sample was chosen.

     Fix: read the product JSON that product-options.liquid already emits, watch
     the hidden input for a new id, then re-point basePrice at that variant and
     re-run the widget's normal update path. */
  const variantData = (function() {
    const out = { price: {}, plan: {} };
    try {
      const el = document.querySelector('.js-product-options script[type="application/json"]');
      const data = el ? JSON.parse(el.textContent) : null;
      const list = data && data.product && data.product.variants;
      (list || []).forEach(function(v) {
        out.price[String(v.id)] = v.price / 100;
        /* Each variant carries its OWN selling_plan_allocations. On this store
           different variants sit on different plans (e.g. holi mane: 30-day
           supply -> "Delivery every 30 days", 90-day supply -> "90 day
           subscription"), so the single hardcoded selling_plans.first.id in
           recharge-subscription-widget.liquid is wrong for whichever variant
           is not in that plan, and Shopify rejects the add with
           "Cannot apply selling plan to variant [...]". */
        const alloc = v.selling_plan_allocations;
        if (alloc && alloc.length) out.plan[String(v.id)] = String(alloc[0].selling_plan_id);
      });
    } catch (e) {
      console.warn('[subscription-widget] could not read product options JSON:', e);
    }
    return out;
  })();

  function selectedVariantId() {
    const el = document.querySelector('.ProductForm input[name="id"]');
    return el ? String(el.value) : '';
  }

  function moneyText(v) { return '$' + Number(v).toFixed(2); }

  /* Point the widget at the plan the SELECTED variant is actually allowed to
     use. updateUI() reads widget.dataset.sellingPlan into the submitted
     selling_plan input, so re-pointing the dataset is enough for both the
     initial render and every later variant change.
     If the JSON carries no allocations we leave the server-rendered value
     alone — that degrades to the previous behaviour rather than submitting
     something worse. A variant with no plan at all cannot be subscribed to,
     so the Subscribe block is hidden and one-time is forced (this is what the
     v2 PDP already does via selling_plan_allocations). */
  /* True only while one-time is selected because the current variant has no
     plan — i.e. the widget forced it, not the shopper. */
  let planForcedOnetime = false;

  function syncPlanForVariant(id) {
    const planId = variantData.plan[id];
    const subsBlock = subscriptionOptionsSubscribe
      ? (subscriptionOptionsSubscribe.closest('.recharge-options') || subscriptionOptionsSubscribe)
      : null;

    const hasAllocationData = Object.keys(variantData.plan).length > 0;
    if (!hasAllocationData) return;

    if (planId) {
      widget.dataset.sellingPlan = planId;
      if (sellingPlanInput) sellingPlanInput.value = planId;
      if (subsBlock) subsBlock.style.display = '';
      /* Only restore subscribe if WE forced one-time for a plan-less variant —
         never override a one-time the shopper picked deliberately. Mirrors the
         otForced flag the v2 PDP uses. */
      if (planForcedOnetime) {
        planForcedOnetime = false;
        if (subscribeRadio) subscribeRadio.checked = true;
        currentOption = 'subscribe';
        if (subscriptionOptionsSubscribe) subscriptionOptionsSubscribe.classList.add('active');
        if (subscriptionOptionsOnetime) subscriptionOptionsOnetime.classList.remove('active');
      }
    } else {
      planForcedOnetime = true;
      if (subsBlock) subsBlock.style.display = 'none';
      if (onetimeRadio) onetimeRadio.checked = true;
      currentOption = 'onetime';
      if (subscriptionOptionsSubscribe) subscriptionOptionsSubscribe.classList.remove('active');
      if (subscriptionOptionsOnetime) subscriptionOptionsOnetime.classList.add('active');
    }
  }

  function applyVariant(id) {
    const p = variantData.price[id];
    if (typeof p !== 'number') return;

    syncPlanForVariant(id);

    basePrice = p;
    widget.dataset.basePrice = String(p);

    // Server-rendered, and never touched by updateUI — must be set here.
    const crossed = widget.querySelector('.crossed-price');
    if (crossed) crossed.textContent = moneyText(p);

    /* .current-price matches BOTH the subscribe and the one-time block, and
       updateTierAndPrice() only ever writes the first match (subscribe), so
       the one-time figure has to be set explicitly or it keeps the old price. */
    const otPrice = widget.querySelector('#subscription-options-onetime .current-price');
    if (otPrice) otPrice.textContent = moneyText(p);

    updateUI();
  }

  let lastVariantId = selectedVariantId();
  /* Also run once on load: the hardcoded selling_plans.first.id is wrong for
     the default variant too whenever that variant sits on a different plan, so
     the add would fail before the shopper touches anything. This runs before
     the trailing updateUI(), so the corrected plan is what gets rendered. */
  syncPlanForVariant(lastVariantId);

  function checkVariant() {
    const id = selectedVariantId();
    if (id && id !== lastVariantId) {
      lastVariantId = id;
      applyVariant(id);
    }
  }

  /* The listeners give an instant response wherever they do fire; the interval
     is the safety net, since a Preact property write emits neither an event nor
     a mutation record and so cannot be observed directly. */
  document.addEventListener('change', checkVariant, true);
  document.addEventListener('click', function() { setTimeout(checkVariant, 0); }, true);
  setInterval(checkVariant, 250);

  subscribeRadio.addEventListener('change', function() {
    if (this.checked) {
      currentOption = 'subscribe';
      subscriptionOptionsSubscribe.classList.add('active');
      subscriptionOptionsOnetime.classList.remove('active');
      updateUI();
    }
  });

  onetimeRadio.addEventListener('change', function() {
    if (this.checked) {
      currentOption = 'onetime';
      subscriptionOptionsSubscribe.classList.remove('active');
      subscriptionOptionsOnetime.classList.add('active');
      updateUI();
    }
  });

  if (subscribeOption) {
    subscribeOption.addEventListener('click', function() {
      subscribeRadio.checked = true;
      currentOption = 'subscribe';
      updateUI();
    });
  }

  if (onetimeOption) {
    onetimeOption.addEventListener('click', function() {
      onetimeRadio.checked = true;
      currentOption = 'onetime';
      updateUI();
    });
  }

  const input = currentProductQuantity;
  /* Guard: on a sold-out product the quantity input is not rendered, and
     observing null throws — which would take the whole widget down. */
  if (input) {
    let lastValue = input.value;

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                const newValue = input.value;
                if (newValue !== lastValue) {
                    lastValue = newValue;
                    updateUI();
                }
            }
        });
    });

    observer.observe(input, {
      attributes: true,
      attributeFilter: ['value']
    });
  }

  document.addEventListener('rebuy:smartcart.hide', (event) => {
    updateUI();
  });

  function getCurrentQuantity() {
    let qtyInput = document.querySelector('.ProductForm [name="quantity"]');
    if (qtyInput) {
      let value = parseInt(qtyInput.value) || 1;
      return value;
    }
    console.warn('getCurrentQuantity: No quantity input found, returning default value 1');
    return 1;

  }

  function bundleItemsInCart() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const bundleItems = cart.items.filter(item => item.properties['_rc_bundle'] !== undefined);
        if (bundleItems.length > 0) {
          return bundleItems;
        } else {
          return null;
        }
      })
      .catch(error => {
        console.error('Error checking cart for bundle items:', error);
        return null;
      });
  }


  function enableBundleInputs() {
    rcBundleInput.disabled = false;
    bundleItemsInCart().then(bundleItems => {
      let fullBundle = ""
      let nanoidstatic = ""
      if (bundleItems) {
        fullBundle = bundleItems[0].properties['_rc_bundle'];
        nanoidstatic = fullBundle.split(':')[0];
        rcBundleInput.value = `${nanoidstatic}:${productBundleId}`;
      } else {
        rcBundleInput.value = `${nanoid(9)}:${productBundleId}`;
      }
      rcBundleParentInput.disabled = false;
      rcBundleParentInput.value = parentBundle;
      rcBundleVariantInput.disabled = false;
      rcBundleVariantInput.value = variantBundleId;
      rcBundleCollectionIdInput.disabled = false;
      rcBundleCollectionIdInput.value = collectionBundleId;
      });

  }
  function disableBundleInputs() {
    rcBundleInput.disabled = true;
    rcBundleParentInput.disabled = true;
    rcBundleVariantInput.disabled = true;
    rcBundleCollectionIdInput.disabled = true;
  }

  function checkBundleItemsInCart() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const bundleItems = cart.items.filter(item => item.properties['_rc_bundle'] !== undefined);
        let totalQuantity = 0;
        bundleItems.forEach(item => {
          totalQuantity += item.quantity;
        });
        return totalQuantity;
      })
      .catch(error => {
        console.error('Error checking cart for bundle items:', error);
        return 0;
      });
  }

  function updateTierAndPrice() {
      /* Re-read from the dataset rather than trusting the value captured at
         DOMContentLoaded, so a variant change (or anything else that re-points
         data-base-price) is picked up instead of being silently ignored. */
      basePrice = parseFloat(widget.dataset.basePrice) || basePrice;

      const currentProductQuantity = getCurrentQuantity();
      return checkBundleItemsInCart().then(productBundleQuantity => {
        const projectedTotal = productBundleQuantity + currentProductQuantity;

        let discount;
        if (projectedTotal >= 3) {
          discount = tier3Discount;
        } else if (projectedTotal >= 2) {
          discount = tier2Discount;
        } else {
          discount = tier1Discount;
        }
        price = basePrice * (1 - discount / 100);
        widget.querySelector('.current-price').textContent = `$${price.toFixed(2)}`;
        widget.querySelector('#discount-percent').textContent = ` | ${discount}%`;
      }).catch(error => {
        console.error('Error al actualizar precio con bundles:', error);
      });
  }

  function updateUI() {
    if (subscribeOption) {
      subscribeOption.classList.toggle('active', currentOption === 'subscribe');
    }
    if (onetimeOption) {
      onetimeOption.classList.toggle('active', currentOption === 'onetime');
    }

    updateTierAndPrice().then(() => {
      /* Guard: .js-price-preview only exists inside the {% if product.available %}
         branch of product-details.liquid, so it is absent on sold-out products. */
      const pricePreview = document.querySelector('.js-price-preview');
      if (currentOption === 'subscribe') {
        enableBundleInputs();
        sellingPlanInput.disabled = false;
        sellingPlanInput.value = widget.dataset.sellingPlan;
        if (pricePreview) pricePreview.textContent = `$${price.toFixed(2)}`;
      } else {
        if (sellingPlanInput) {
          sellingPlanInput.disabled = true;
        }
        disableBundleInputs();
        if (pricePreview) pricePreview.textContent = `$${basePrice.toFixed(2)}`;
      }
    });
  }


  window.subscriptionWidget = {
    getCurrentOption: function() {
      return currentOption;
    },
    getCurrentSellingPlan: function() {
      return sellingPlanInput ? sellingPlanInput.value : '';
    },
    getCurrentDiscount: function() {
      return discountInput ? parseInt(discountInput.value) : 0;
    },
    hasActiveSubscription: function() {
      return currentOption === 'subscribe' && sellingPlanInput && sellingPlanInput.value;
    },
    getRechargeData: function() {
      const currentProductQuantity = getCurrentQuantity();
      return checkBundleItemsInCart().then(productBundleQuantity => {
        const projectedTotal = productBundleQuantity + currentProductQuantity;
        let tierDiscount = tier1Discount;
        if (projectedTotal >= 3) {
          tierDiscount = tier3Discount;
        } else if (projectedTotal >= 2) {
          tierDiscount = tier2Discount;
        }

        return {
          variantId: widget.dataset.productId,
          quantity: currentProductQuantity,
          sellingPlan: sellingPlanInput ? sellingPlanInput.value : '',
          tierDiscount: tierDiscount,
          purchaseOption: currentOption,
          projectedTotal: projectedTotal
        };
      });
    },
    checkBundleItemsInCart: function() {
      return checkBundleItemsInCart();
    },
    updateQuantity: function() {
      currentProductQuantity.value = 4;
    },
    // Lets external code force a re-render (e.g. after changing data-base-price).
    refresh: function() {
      updateUI();
    }
  };

  updateUI();
});